import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { CaravanCoverage } from "Store/interfaces/products/coverage";
import { Movables } from "../constants";
import { CaravanProductPriceFormValues } from "./interfaces";

export const validationSchema =
  (): Yup.ObjectSchema<CaravanProductPriceFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      coverage: Yup.mixed<CaravanCoverage>()
        .oneOf(Object.values(CaravanCoverage))
        .required(),
      deductible: Yup.string().required(),
      movables: Yup.mixed<Movables>()
        .oneOf(Object.values(Movables))
        .required(getText("caravanform.validation.movables")),
    });
  };
